/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
    <path d="M1.6665 7.91711C1.66652 6.98977 1.94783 6.08426 2.47328 5.32016C2.99873 4.55606 3.7436 3.96932 4.60951 3.63744C5.47542 3.30556 6.42164 3.24414 7.32318 3.46131C8.22473 3.67848 9.03919 4.16401 9.659 4.85377C9.70266 4.90045 9.75544 4.93767 9.81407 4.96311C9.8727 4.98855 9.93593 5.00168 9.99984 5.00168C10.0637 5.00168 10.127 4.98855 10.1856 4.96311C10.2442 4.93767 10.297 4.90045 10.3407 4.85377C10.9585 4.15952 11.7732 3.66991 12.6762 3.45011C13.5792 3.2303 14.5277 3.29073 15.3956 3.62334C16.2634 3.95596 17.0093 4.54498 17.5341 5.31203C18.0589 6.07907 18.3376 6.98774 18.3332 7.91711C18.3332 9.82544 17.0832 11.2504 15.8332 12.5004L11.2565 16.9279C11.1012 17.1063 10.9098 17.2495 10.6949 17.3482C10.48 17.4468 10.2465 17.4986 10.0101 17.5001C9.77362 17.5016 9.53954 17.4528 9.32341 17.3569C9.10728 17.261 8.91403 17.1201 8.7565 16.9438L4.1665 12.5004C2.9165 11.2504 1.6665 9.83377 1.6665 7.91711Z" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
